import { Repack } from 'types/generated/graphql';

export const isRepack = (item: unknown): item is Repack => {
    return (item as Repack).__typename === 'Repack';
};
